import * as React from "react";

import { Video } from "../../types";
import useFetchVideo from "../../hooks/videos/useFetchVideo";

import VideoPreview from "./VideoPreview";
import { Space } from "../../styled-component";
import Layout from "../common/Layout";
import Text from "../common/Text";

export interface VideoOneProps {
  video?: Video;
  videoId?: Video["id"];
}

function VideoOne({ video: videoProp, videoId }: VideoOneProps) {
  const { data } = useFetchVideo(videoId, { enabled: !!videoId });
  const video = data || videoProp;
  const { url, name } = video || {};

  return (
    <Layout.Column alignItems="center">
      <VideoPreview url={url} />

      <Space />

      <Text.SubHeader numberOfLines={1}>{name || url}</Text.SubHeader>
    </Layout.Column>
  );
}

export default VideoOne;
